// CARD ITSELF JS AND SECOND IMAGE + TEXT

document.addEventListener("DOMContentLoaded", function () {
  let activeCard = null;
  let resetTimeout = null;
  let isMobile = window.innerWidth <= 800;
  let eventListenerAttached = false;

  function enableMobileMode() {
    if (eventListenerAttached) return;
    eventListenerAttached = true;
    document.body.addEventListener("click", mobileClickHandler);
  }

  function disableMobileMode() {
    if (!eventListenerAttached) return;
    eventListenerAttached = false;
    document.body.removeEventListener("click", mobileClickHandler);
    resetCard(activeCard);
  }

  function mobileClickHandler(event) {
    const card = event.target.closest(".collection-card");
    if (!card) return;

    const imageContainer = card.querySelector(
      ".collection-card-image-container"
    );
    if (!imageContainer.contains(event.target)) return;

    event.preventDefault();

    if (activeCard && activeCard !== card) {
      resetCard(activeCard);
      clearTimeout(resetTimeout);
    }

    if (activeCard === card) {
      window.location.href = card.querySelector("a").href;
      return;
    }

    setActiveCard(card);

    resetTimeout = setTimeout(() => {
      if (activeCard === card) resetCard(card);
    }, 5000);
  }

  function setActiveCard(card) {
    resetCard(activeCard);
    activeCard = card;
    card.classList.add("collection-card-mobile-active"); // Apply mobile behavior via CSS
  }

  function resetCard(card) {
    if (!card) return;
    card.classList.remove("collection-card-mobile-active"); // Remove mobile behavior via CSS
    activeCard = null;
  }

  function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  function checkScreenSize() {
    const newIsMobile = window.innerWidth <= 800;
    if (newIsMobile !== isMobile) {
      isMobile = newIsMobile;
      isMobile ? enableMobileMode() : disableMobileMode();
    }
  }

  const debouncedCheckScreenSize = debounce(checkScreenSize, 150);
  window.addEventListener("resize", debouncedCheckScreenSize);

  // **Force immediate activation on first load if in mobile mode**
  if (isMobile) {
    enableMobileMode();
  }

  checkScreenSize(); // Ensure behavior is properly initialized
});

// COLOUR DOTS VARIANT IMAGE SWITCH SYSTEM

// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll(".colour-dot").forEach((dot) => {
//     dot.addEventListener("click", () => {
//       const newImageSrc = dot.dataset.image;
//       const productId = dot.dataset.target;
//       const firstImage = document.querySelector(
//         `.collection-card-first-image[data-product-id="${productId}"]`
//       );
//       const imageContainer = firstImage.closest(
//         ".collection-card-image-container"
//       );

//       if (newImageSrc && firstImage) {
//         // Add loading class to make the image faded
//         firstImage.classList.add("collection-card-image-loading");

//         // Create and show the spinner
//         let loader = imageContainer.querySelector(".collection-card-loader");
//         if (!loader) {
//           loader = document.createElement("div");
//           loader.classList.add("collection-card-loader");
//           imageContainer.appendChild(loader);
//         }
//         loader.style.display = "block";

//         // Preload the new image
//         const img = new Image();
//         img.src = newImageSrc;
//         img.onload = () => {
//           firstImage.src = newImageSrc;
//           firstImage.classList.remove("collection-card-image-loading"); // Remove fade
//           loader.style.display = "none"; // Hide spinner
//         };
//       }
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".colour-dot").forEach((dot) => {
    dot.addEventListener("click", () => {
      const newImageSrc = dot.dataset.image;
      const productId = dot.dataset.target;
      const firstImage = document.querySelector(
        `.collection-card-first-image[data-product-id="${productId}"]`
      );
      const imageContainer = firstImage.closest(
        ".collection-card-image-container"
      );

      if (newImageSrc && firstImage) {
        // Add loading class to make the image faded
        firstImage.classList.add("collection-card-image-loading");

        // Create and show the spinner
        let loader = imageContainer.querySelector(".collection-card-loader");
        if (!loader) {
          loader = document.createElement("div");
          loader.classList.add("collection-card-loader");
          imageContainer.appendChild(loader);
        }
        loader.style.display = "block";

        // Preload the new image
        const img = new Image();
        img.src = newImageSrc;
        img.onload = () => {
          firstImage.src = newImageSrc;
          firstImage.classList.remove("collection-card-image-loading"); // Remove fade
          loader.style.display = "none"; // Hide spinner
        };

        // Remove active class from all dots in the same product card
        dot
          .closest(".colour-dots")
          .querySelectorAll(".colour-dot")
          .forEach((d) => {
            d.classList.remove("active");
          });

        // Add active class to the clicked dot
        dot.classList.add("active");
      }
    });
  });
});
